"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var HandleRequest_1 = require("../../../../../common/js/services/requestHttp/HandleRequest");
var SelfDecouverte = /** @class */ (function (_super) {
    __extends(SelfDecouverte, _super);
    function SelfDecouverte($view) {
        var _this = _super.call(this, $view) || this;
        _this.formContainer = _this.$view.find('#form-container');
        _this.currentStep = parseInt(_this.formContainer.attr('data-step'), 10);
        _this.lead = parseInt(_this.formContainer.attr('data-lead'), 10);
        _this.initListeners();
        return _this;
    }
    SelfDecouverte.prototype.initListeners = function () {
        var _this = this;
        this.$view.on('submit', '#selfdecouverte-form', function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, this.sendForm()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    SelfDecouverte.prototype.sendForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, RequestData, currentStep, response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = $('#selfdecouverte-form').attr('action');
                        this.purgeErrors();
                        currentStep = parseInt($('#form-container').attr('data-step'), 10);
                        switch (currentStep) {
                            case (1):
                                RequestData = this.getLeadInfo();
                                break;
                            case (2):
                                RequestData = this.getQuestionInfo();
                                break;
                            case (3):
                                RequestData = this.getLastStepInfo();
                                break;
                        }
                        return [4 /*yield*/, (0, HandleRequest_1.send)(url, 'POST', (0, HandleRequest_1.formDataFromObject)(RequestData))];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        if (response.ok) {
                            if (data.gtm) {
                                //@ts-ignore
                                HegydGtm.pushToDatalayer(data.gtm);
                            }
                            switch (currentStep) {
                                case (3):
                                    window.location.href = data.url;
                                    break;
                                default:
                                    this.$view.html(data.template);
                                    break;
                            }
                        }
                        else {
                            this.showErrors(data);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SelfDecouverte.prototype.purgeErrors = function () {
        this.$view.find(".form-group").removeClass("js-form-group-error").find(".error").removeClass("text-warning").text("");
    };
    SelfDecouverte.prototype.showErrors = function (errors) {
        var _this = this;
        $.each(errors, function (key, value) {
            if (key == "g-recaptcha-response") {
                _this.$view.find(".error-captcha").html(' <div class="col-md-12 alert-inner">\n' +
                    '            <div class="alert alert-danger" id="no_valide_code" role="alert">' + value + '</div>\n' +
                    '        </div>');
            }
            else {
                key = key.replace(/_/g, "-"); // pas de _ (underscore) dans un selecteur CSS
                _this.$view
                    .find(".js-form-group-" + key)
                    .addClass("form-group-error")
                    .find(".error")
                    .addClass("text-warning")
                    .text(value);
            }
        });
    };
    SelfDecouverte.prototype.getLeadInfo = function () {
        var product = $('#form-container').data('product');
        var token = $("#g-recaptcha-response").val();
        return {
            email: this.$view.find('input[name="email"]').val().toString(),
            lastname: this.$view.find('input[name="lastname"]').val().toString(),
            firstname: this.$view.find('input[name="firstname"]').val().toString(),
            telephone: this.$view.find('input[name="telephone"]').val().toString(),
            zip: this.$view.find('input[name="zip"]').val().toString(),
            cpProject: this.$view.find('input[name="cp-project"]').val().toString(),
            product_id: product,
            'g-recaptcha-response': token
        };
    };
    SelfDecouverte.prototype.getQuestionInfo = function () {
        var currentLead = parseInt($('#form-container').data('lead'), 10);
        var selfdecouverte = parseInt($('#form-container').data('selfdecouverte'), 10);
        var answer = this.$view.find('input[name=answer]:checked').val();
        var customAnswer = this.$view.find('input[name=custom_answer]').val();
        var questionId = this.$view.find('input[name=questionId]').val();
        if (!customAnswer && !answer) {
            this.$view.find('.errorhandler').html('Merci d\'indiquer votre réponse');
            return;
        }
        return {
            currentStep: this.currentStep.toString(),
            currentLead: currentLead,
            selfdecouverte: selfdecouverte,
            answer: (answer ? answer.toString() : ''),
            customAnswer: (customAnswer ? customAnswer.toString() : ''),
            questionId: questionId
        };
    };
    SelfDecouverte.prototype.getLastStepInfo = function () {
        var currentLead = parseInt($('#form-container').data('lead'), 10);
        var selfdecouverte = parseInt($('#form-container').data('selfdecouverte'), 10);
        return {
            currentStep: this.currentStep.toString(),
            currentLead: currentLead,
            selfdecouverte: selfdecouverte,
            message: $('#message').val()
        };
    };
    return SelfDecouverte;
}(BaseComponent_1.default));
exports.default = SelfDecouverte;
